// components/client/AuthProviderClient.jsx
"use client";
import AuthProvider from "@/context/AuthProvider";
import DealerTrackingRetry from "./DealerTrackingRetry";

export default function AuthProviderClient({
  children,
  initialUser,
  initialCustomToken,
}) {
  return (
    <AuthProvider
      initialUser={initialUser}
      initialCustomToken={initialCustomToken}
    >
      <DealerTrackingRetry />
      {children}
    </AuthProvider>
  );
}
